import React, { useEffect, useState } from "react";
import axios from "axios";
import { BaseApi } from "../base.api";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button, Card, Col, Input, Row, Spin } from "antd";
import TextArea from "antd/es/input/TextArea";
import Editor from "react-simple-wysiwyg";
const UpdateTranslation = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true)
  const location = useLocation();
  const { key } = location.state || {};
  console.log(key);
  
  const [translations, setTranslations] = useState([
    { language: "az", value: "" },
    { language: "en", value: "" },
    { language: "ru", value: "" },
    { language: "tr", value: "" },
    { language: "pl", value: "" },
    { language: "kz", value: "" },
  ]);
  const languageMapping:any = {
    az: "Azerbaijani",
    en: "English",
    ru: "Russian",
    tr: "Turkish",
    pl: "Polish",
    kz: "Kazakh",
  };
  useEffect(() => {
    console.log(translations);

    const fechTranslations = async () => {
      try {
        const response = await new BaseApi().fetchData(
          `common-service/v1/translations/by-key/${key}`
        );
        if (response?.data.data) {
          const updateTranslation = translations.map(translation => {
            const existingData = response?.data.data.find((item:any)=>item.language === translation.language)
            return{
              ...translation,
              value: existingData? existingData.value : ''
            }   
          })
          setTranslations(updateTranslation)
     
        }
        
      } catch (error) {
        console.log(error);
        
      }finally {
        setLoading(false)
      }
    };
    if (key) {
      fechTranslations();
    }
  }, [key]);

  const handleTranslationChange = (index: any, event: any) => {
    const newTranslations = [...translations];
    newTranslations[index].value = event.target.value;
    setTranslations(newTranslations);
    
  };
  const handleUpdate = async () => {
    
    const payload = {
      key: key,
      translations,
    };
    try {
      const response = await new BaseApi().postData(
        `/common-service/v1/translations`,
        payload
      );
      if (response) {
        // console.log("succesfully");
        navigate("/main/translations");
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
    <Button><Link to={"/main/translations"}>Back</Link></Button>
    {loading ? (
      <div style={{ textAlign: "center", marginTop: 200,marginBottom:398   }}>
        <Spin size="large" />
      </div>
    ) : (
    <Card className="card-container" style={{ width: 700, marginLeft: 370 }} title="Update Translation">
     
      <form>
        <Row gutter={16}>
          <Col span={24}>
            <div>
              <label style={{fontWeight:"bold"}}>Key: </label>
              <Input style={{marginBottom:"12px"}} type="text" value={key} />
            </div>
          </Col>
          {translations.length > 0 &&
            translations.map((translation, index) => (
              <Col span={24} key={index}>
                <div>
                <label style={{fontWeight:"bold"}}>{languageMapping[translation.language]} Translation: </label>
                {key.startsWith("ntf") || key.startsWith("errors") || key.startsWith("tooltip") || key.startsWith("template")  || key.startsWith("filter") || key.startsWith("htmls") ?(
                  <div  style={{marginBottom:"12px"}}>
                    <Editor
                        value={translation.value}
                        onChange={(e) => handleTranslationChange(index, e)}
                        placeholder={`Enter value in ${languageMapping[translation.language]}`}
                        disabled={loading}
                    />

                  </div>
                ):(
                  <TextArea
                    style={{marginBottom:"12px"}}
                    value={translation.value}
                    onChange={(e) => handleTranslationChange(index, e)}
                    placeholder={`Enter value in ${languageMapping[translation.language]}`}
                    disabled={loading}
                />)
                }
                </div>
              </Col>
            ))}
        </Row>
        <Row justify="center" style={{ marginTop: 16 }}>
          <Col>
            <Button type="primary" onClick={handleUpdate}>
              Save
            </Button>
          </Col>
        </Row>
      </form>
      </Card>
      )}
      </>
  );
};

export default UpdateTranslation;
